import { EditOutlined, HistoryOutlined } from '@ant-design/icons'
import { Button, Card, Modal, Space, Statistic } from 'antd'
import { useState } from 'react'

import { useGpuSettings } from '../hooks/useGpuAdmin'
import { usePatchGpuSettings } from '../hooks/useGpuMutations'
import { HistoryTable } from './HistoryTable'
import { MarkupModal } from './MarkupModal'

export function GlobalMarkupCard({ canWrite }: { canWrite: boolean }) {
  const { data } = useGpuSettings()
  const patch = usePatchGpuSettings()
  const [open, setOpen] = useState(false)
  const [historyOpen, setHistoryOpen] = useState(false)

  if (!data) return null

  return (
    <Card size="small" style={{ marginBottom: 16 }}>
      <Space size="large" align="center" wrap>
        <Statistic
          title={
            data.source === 'database'
              ? 'Global markup'
              : 'Global markup (environment default)'
          }
          value={data.effective_markup_percent}
          suffix="%"
        />
        {canWrite && (
          <Button icon={<EditOutlined />} onClick={() => setOpen(true)}>
            Change global markup
          </Button>
        )}
        <Button icon={<HistoryOutlined />} onClick={() => setHistoryOpen(true)}>
          Global markup history
        </Button>
      </Space>
      <Modal
        title="Global markup history"
        open={historyOpen}
        footer={null}
        width={800}
        onCancel={() => setHistoryOpen(false)}
        destroyOnHidden
      >
        <HistoryTable />
      </Modal>
      <MarkupModal
        open={open}
        target="all providers without their own markup"
        current={data.markup_percent}
        inheritLabel="Use environment default"
        loading={patch.isPending}
        onSubmit={(value) => patch.mutateAsync(value)}
        onClose={() => setOpen(false)}
      />
    </Card>
  )
}
